import { instance as axios } from '../untils/http'
import { createSlice, createAsyncThunk,PayloadAction} from "@reduxjs/toolkit";
import { RegisterMFAType } from "src/models/auth";
import { store } from "../store";
import { errorHandler } from '../untils/errorHandler';
interface UserState {
  loading: boolean;
  error: string | null;
  registerMFAType: RegisterMFAType[];
}

const initialState: UserState = {
  loading: false,
  error: null,
  registerMFAType: []
};

export const changepass = createAsyncThunk(
  "account/changepass",
  async (paramaters: {
    oldPassword: string,
    newPassword: string,
  }, { rejectWithValue })=>{
    try {
        const  response = await axios.post(
        `/Account/changepassword`,{
            oldPassword: paramaters.oldPassword,
            newPassword: paramaters.newPassword
        }
        )
    return response.data[0];
    }catch (err) {
      return rejectWithValue(errorHandler(err))
    }
  }
)

export const registermfa = createAsyncThunk(
  "account/registermfa",
  async ()=>{
    try {
        const  response = await axios.get(`/Account/registermfa`,)
    return {
      registerMFAType: response.data,
    }
    }catch (err) {
        return err.response.data[0];
    }
  }
)

export const Updatemfa = createAsyncThunk(
  "account/Updatemfa",
  async (paramaters: {
    verifycode: string,
  }, thunkAPI)=>{
    try {
        const  response = await axios.put(`/Account/registermfa`,{
          pin: paramaters.verifycode
        })
        
    console.log(response.data[0]);
    return response.data[0];
    }catch (err) {
        return err.response.data[0];
    }
  }
)

export const Verifymfa = createAsyncThunk(
  "account/Verifymfa",
  async (paramaters: {
    verifycode: string,
  }, thunkAPI)=>{
    try {
        const  response = await axios.post(`/Account/verifymfa`,{
          pin: paramaters.verifycode
        })
        
        //return response.status;
    console.log(response.status);
    if(response.status === 200){
      var temptoken = localStorage.getItem("tempauthtoken")
      localStorage.setItem("authtoken" , temptoken);
      localStorage.removeItem('tempauthtoken');
      return response.status;
    }
    }catch (err) {
        return err.response.status;
    }
  }
)

export const accountSlice = createSlice({
  name:'account',
  initialState,
  reducers:{},
  extraReducers: {
    [changepass.pending.type]: (state) => {
      state.loading = true;
    },
    [changepass.fulfilled.type]: (state, action) => {
      state.loading = false;
      state.error = null;
    },
    [changepass.rejected.type]: (state, action: PayloadAction<string | null>) => {
      state.loading = false;
      state.error = action.payload;
    },
    [registermfa.pending.type]: (state) => {
      state.loading = true;
    },
    [registermfa.fulfilled.type]: (state, action) => {
      const { registerMFAType } = action.payload
      state.registerMFAType = registerMFAType;
      state.loading = false;
    },
    [registermfa.rejected.type]: (state, action: PayloadAction<string | null>) => {
        state.loading = false;
        console.log(action)
        state.error = action['error']
    },
    ////// For Update MFA
    [Updatemfa.pending.type]: (state) => {
      state.loading = true;
    },
    [Updatemfa.fulfilled.type]: (state, action) => {
        state.loading = false;
        state.error = null;
    },
    [Updatemfa.rejected.type]: (state, action: PayloadAction<string | null>) => {
        state.loading = false;
      
        state.error = action.payload;
        console.log( state.error)
    },

    ////// For Verify MFA
    [Verifymfa.pending.type]: (state) => {
      state.loading = true;
    },
    [Verifymfa.fulfilled.type]: (state, action) => {
        state.loading = false;
        state.error = null;
    },
    [Verifymfa.rejected.type]: (state, action: PayloadAction<string | null>) => {
        state.loading = false;
      
        state.error = action.payload;
        console.log( state.error)
    },
  }
})

export default accountSlice
// // export const postReducer = userSlice.reducer
// export const { setLoading } = accountSlice.actions
// export default accountSlice.reducer;